export default __webpack_public_path__ + "static/media/Reports.3b375e3b.jpg";